import { Controller } from 'react-hook-form';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';

export const DefaultLanguageField = ({
  field,
  data,
  control,
  readonly,
  setValue,
  watch = (() => {}) as (key?: any) => any,
  compact,
}) => {
  const fieldValue = watch(field.key);
  const [selectValue, setSelectValue] = useState({
    key: '',
    value: '',
  });
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (field) {
      setOptions(field.options);
    } else {
      setOptions([]);
    }
  }, [field]);

  useEffect(() => {
    if (options.length) {
      if (readonly) {
        if (data) {
          const option = options.find(
            (option) => option.key === (data?.value?.toLowerCase() || data?.toLowerCase()),
          );
          setValue('pf_default_language', option || {});
          setSelectValue(option || { key: '', value: '' });
        } else if (field?.default_value) {
          const option = options.find((option) => option.key === field?.default_value.key);
          setValue('pf_default_language', option || {});
          setSelectValue(option || { key: '', value: '' });
        }

        return;
      }

      if (!fieldValue?.value) {
        if (data) {
          const option = options.find(
            (option) => option.key === (data?.value?.toLowerCase() || data?.toLowerCase()),
          );
          setValue('pf_default_language', option || {});
          setSelectValue(option || { key: '', value: '' });
        } else if (field?.default_value) {
          const option = options.find((option) => option.key === field?.default_value.key);
          setValue('pf_default_language', option || {});
          setSelectValue(option || { key: '', value: '' });
        }
      } else {
        const string = typeof fieldValue === 'string' ? fieldValue : fieldValue.key;
        const option = options.find((option) => option.key === string);

        setValue('pf_default_language', option || {});
        setSelectValue(option || { key: '', value: '' });
      }
    }
  }, [options, data, readonly]);

  return Boolean(field && options.length) ? (
    <div className={'flex flex-1 flex-col gap-[5px]'}>
      <div>
        <p className={'text-ebony_opacity_30 text-xs font-medium'}>Default language</p>
      </div>
      <div>
        <Controller
          control={control}
          name="pf_default_language"
          render={() => (
            <Select
              getOptionLabel={(option) => option.value}
              getOptionValue={(option) => option.key}
              isDisabled={readonly}
              onChange={(value) => {
                setValue('pf_default_language', value);
                setSelectValue(value);
              }}
              defaultValue={selectValue}
              value={selectValue}
              name="pf_default_language"
              placeholder={'Choose Language'}
              options={options}
              classNamePrefix="select"
              styles={{
                placeholder: (baseStyles, state) => ({
                  ...baseStyles,
                  color: '#B8C1C6',
                }),
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  boxShadow: 'none',
                  borderColor: state.isFocused ? '#a498ff80!important' : '#E3E6E8',
                  fontFamily: 'Bai Jamjuree',
                  fontSize: '14px',
                  fontWeight: '500',
                  background: state.isDisabled ? '#fff' : baseStyles.background,
                }),
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  background: state.isSelected || state.isFocused ? '#a498ff1a' : baseStyles.color,
                  color: state.isSelected ? 'rgba(5, 5, 13);' : 'rgba(5, 5, 13, 0.50);',
                  fontFamily: 'Bai Jamjuree',
                  fontSize: '14px',
                  fontWeight: '500',
                }),
              }}
            />
          )}
        />
      </div>
    </div>
  ) : null;
};
